module.exports = __webpack_public_path__ + "static/media/corona-time.e5711cc2.mp3";